import React from "react";
import BingoPlayersList from "../components/BingoPlayersList";
import _ from "lodash";

function Over({
  winners,
  users,
  bad_bingos,
  current_player_details,
  gameParams
}) {
  const over_params = _.get(gameParams, "6_over");
  const badbingos_label = _.get(over_params, "badbingos_label", "BAD BINGOS:");
  const thanks_text = _.get(over_params, "thanks_text", "THANKS FOR PLAYING!");
  const winnders_label = _.get(
    over_params,
    "winnders_label",
    "WE HAVE WINNERS!"
  );
  const winner_label = _.get(over_params, "winner_label", "WE HAVE A WINNER!");
  const winnerself_label = _.get(over_params, "winnerself_label", "YOU WIN!");
  const winnerself_text = _.get(
    over_params,
    "winnerself_text",
    "BASK IN THE GLORY OF VICTORY!"
  );

  const winner_players_details = users.filter((user) =>
    winners?.includes(user.player_id)
  );
  const bad_bingo_players = users.filter((user) =>
    bad_bingos?.includes(user.player_id)
  );
  const multiple_winners = winner_players_details.length > 1;
  console.log(
    bad_bingo_players,
    "bad_bingo_players",
    _.isEmpty(bad_bingo_players)
  );
  return (
    <>
      <div className="bingo-over-wrapper">
        {/* <h2 className="winner-txt">{multiple_winners ? "We have Winners!" : "we have a winner"}</h2> */}
        {winners?.includes(current_player_details.player_id) ? (
          <>
            <h1 className="winner-txt">{winnerself_label}</h1>
            <h2 className="winner-txt2">{winnerself_text}</h2>
          </>
        ) : (
          <h2 className="winner-txt">
            {multiple_winners ? winnders_label : winner_label}
          </h2>
        )}
        {!multiple_winners && (
          <div className="winner-img">
            <img src={winner_players_details[0]?.profile_image} alt="" />
            <p className="winner-name">
              {winner_players_details[0]?.display_name}
            </p>
          </div>
        )}

        <div className="bad-bingos">
          <h4 className="bad-txt">{badbingos_label}</h4>
          <div
            className={`bad-bingos-box ${
              _.isEmpty(bad_bingo_players) ? "none" : ""
            }`}
          >
            {_.isEmpty(bad_bingo_players) ? (
              <p> none</p>
            ) : (
              <ul>
                {bad_bingo_players.map((player) => (
                  <li>{player?.display_name}</li>
                ))}
              </ul>
            )}
          </div>
        </div>

        {multiple_winners && (
          <div className="winners-list">
            <BingoPlayersList players={winner_players_details} />
          </div>
        )}
        <h3 className="thanx-txt">{thanks_text}</h3>
      </div>
    </>
  );
}

export default Over;
